module.exports = __webpack_public_path__ + "img/notfound.50ff5d20.png";